import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SignatureIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Signature",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15 27.5h-.1c-.39 0-.77-.07-1.13-.19h.02a4.2 4.2 0 0 1-2.58-2.18v-.02c-1.34-2.67-.01-6.44 1.43-10.8l.27-.79c.41-1.24 1.08-3.2 1.39-4.62a27.8 27.8 0 0 0-4.56 6.63l-.07.16c-1.46 2.66-2.97 5.91-4.29 9.26l-.21.61c-.23.76-.93 1.3-1.75 1.3a1.83 1.83 0 0 1-1.83-1.83c0-.93 2.96-7.56 4.86-11.02 3.81-7.21 7.05-10.26 9.87-9.36.56.16 1.03.51 1.33.98s.11.2.11.2c.89 1.72.07 4.49-1.39 8.89l-.28.81c-.99 2.96-2.28 6.68-1.64 7.99.14.29.28.32.36.34l.21.07c.66-.2 1.75-3.11 2.21-4.35.49-1.45 1.02-2.68 1.64-3.86l-.07.14c.33-.73.91-1.29 1.63-1.59h.02c.17-.07.37-.1.58-.1.95 0 1.73.73 1.82 1.66v.3c0 1.02-.16 2-.47 2.91l.02-.07c-.19.78-.66 2.77-.37 3.05s2.54.48 5.85-.19q.3-.12.66-.12c1.01 0 1.83.82 1.83 1.83s-.75 1.76-1.7 1.82c-4.57.94-7.64.68-9.12-.75q-.165-.15-.3-.33c-1 1.82-2.26 3.23-4.26 3.23Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1 29.29c-.08 0-.17 0-.25-.03-.62-.14-1-.75-.86-1.37L4.91 5.78a5.02 5.02 0 0 1 4.92-3.93c1.54 0 2.98.69 3.94 1.9s1.32 2.76.98 4.26l-3.77 16.58c-.13.59 0 1.19.38 1.66s.93.74 1.54.74c.88 0 1.66-.6 1.89-1.45l2.46-9.02a4.42 4.42 0 0 1 4.25-3.25c1.35 0 2.61.61 3.46 1.67a4.36 4.36 0 0 1 .83 3.75l-1.51 6.43c-.14.61-.76 1-1.38.85-.61-.14-1-.76-.85-1.38l1.51-6.43c.15-.63 0-1.29-.4-1.8s-1.01-.81-1.66-.81c-.96 0-1.8.64-2.05 1.57l-2.46 9.02a4.26 4.26 0 0 1-4.1 3.13c-1.3 0-2.51-.58-3.32-1.6a4.23 4.23 0 0 1-.82-3.59L12.52 7.5c.19-.82 0-1.67-.53-2.33a2.75 2.75 0 0 0-2.16-1.04c-1.3 0-2.4.88-2.69 2.15L2.11 28.4c-.12.53-.59.89-1.11.89"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.75 29.29c-1.17 0-2.26-.53-2.98-1.44-.73-.92-.99-2.1-.72-3.24l.17-.73c.15-.61.76-.99 1.38-.85.61.14 1 .76.85 1.38l-.17.73c-.11.45 0 .92.29 1.29s.72.58 1.19.58c.62 0 1.17-.37 1.4-.94l2.46-5.97c.24-.58.91-.86 1.49-.62s.86.91.62 1.49l-2.46 5.97a3.79 3.79 0 0 1-3.52 2.35"
      })]
    })
  }));
};
SignatureIcon.displayName = 'SignatureIcon';